import { ImageOff, MessageCircle } from "lucide-react";
import { imgSrc } from "@/lib/api";
import { productEnquiry } from "@/lib/store";
import { StatusBadge } from "./StatusBadge";

export const ProductCard = ({ product, onOpen, preview = false }) => {
  const img = product.images?.[0];
  const src = img?.url || img?.previewUrl;
  return (
    <article data-testid={`product-card-${product.slug || "preview"}`}
             className="group flex h-full flex-col overflow-hidden rounded-2xl border border-[#E5E0D8] bg-white transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-22px_rgba(27,67,50,.45)]">
      <button type="button" onClick={() => onOpen?.(product)} className="relative block aspect-[4/3] overflow-hidden bg-[#F4EEE2] text-left" data-testid="product-card-open-btn" aria-label={`View ${product.name}`}>
        {src ? (
          <img src={imgSrc(src)} alt={product.name} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
        ) : (
          <span className="grid h-full w-full place-items-center text-[#8B5A2B]/60"><ImageOff className="h-8 w-8" /></span>
        )}
        {product.is_demo && (
          <span className="absolute left-3 top-3 rounded-full bg-[#10291F]/80 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-[#F3DB8C]" data-testid="demo-badge">Sample listing</span>
        )}
      </button>
      <div className="flex flex-1 flex-col p-4 sm:p-5">
        <div className="flex items-center justify-between gap-2">
          <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#8B5A2B]">{product.category}</span>
          <StatusBadge status={product.availability_status} testId="product-card-status" />
        </div>
        <h3 className="mt-2 font-display text-lg sm:text-xl font-semibold leading-snug text-[#1F2421]">{product.name || "Product name"}</h3>
        <p className="mt-1 text-sm text-[#5B625D]">{[product.material, product.size].filter(Boolean).join(" · ") || "\u00a0"}</p>
        {(product.brands?.length > 0 || product.variants?.length > 0) && (
          <p className="mt-2 text-xs text-[#5B625D]">
            {[product.brands?.length && `${product.brands.length} brand${product.brands.length > 1 ? "s" : ""}`,
              product.variants?.length && `${product.variants.length} size${product.variants.length > 1 ? "s" : ""}`].filter(Boolean).join(" · ")} available
          </p>
        )}
        <div className="mt-auto flex gap-2 pt-4">
          <button type="button" onClick={() => onOpen?.(product)} className="h-11 flex-1 rounded-full border border-[#1B4332]/30 text-sm font-semibold text-[#1B4332] transition-colors hover:bg-[#1B4332] hover:text-white" data-testid="product-card-details-btn">
            View details
          </button>
          <a href={preview ? undefined : productEnquiry(product)} target="_blank" rel="noopener noreferrer" aria-label={`Enquire about ${product.name} on WhatsApp`}
             className="grid h-11 w-11 place-items-center rounded-full bg-[#25D366] text-white transition-transform hover:scale-105" data-testid="product-card-whatsapp-btn">
            <MessageCircle className="h-5 w-5" />
          </a>
        </div>
      </div>
    </article>
  );
};
